<div class="hero allHeightContent">
  <div class="loginPage" id="id-loginPage">
    <div class="loginPageInner">
      <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
        <app-text-input
          [control]="emailControl"
          [label]="'Email'"
          [type]="'email'"
          [required]="true"
          [hideRequiredMarker]="true"
          [autocomplete]="'off'"
          [classes]="'fullWidth'"
          [appearance]="'fill'"
          [id]="'id-emailInput'"
        ></app-text-input>
        <app-password-input
          [control]="passwordControl"
          [label]="'Password'"
          [required]="true"
          [hideRequiredMarker]="true"
          [autocomplete]="'off'"
          [classes]="'fullWidth'"
          [appearance]="'fill'"
          [id]="'id-passwordInput'"
        ></app-password-input>
        <app-button
          [label]="'Log In'"
          [color]="'primary'"
          [type]="'submit'"
          [extraClass]="'loginButton'"
        ></app-button>
        <app-error-message [message]="errorMessage"></app-error-message>
      </form>
    </div>
  </div>
</div>
<app-spinner #spinner></app-spinner>
